import AirtableBase from "./AirtableBase";
import {
	AnnouncementTable,
	CalendarTable,
	SubjectTable,
	TeacherTable,
	CourseTable,
	UnitTable,
	WeekTable,
	LessonTable,
	ResourceTable,
	ResourceSubmissionsTable,
	FriendsOfDwfPartnerTable,
	MessagesTable,
	BookingsTable,
	ResponsesTable,
	ArtistAmbassadorTable,
	ArtistAmbassadorEventTable
} from "./tables";

const AIRTABLE_APP = "apprWesJGBmsmfsWx";

// Call the Cloud Function directly (not through Firebase Hosting rewrites)
// because Hosting strips the Authorization header that the Airtable SDK sends.
const PROXY_ENDPOINT = process.env.REACT_APP_AIRTABLE_PROXY_URL
	|| "https://airtableproxy-psmwtza64a-uc.a.run.app";

export class Airtable extends AirtableBase {
	teachers: TeacherTable;
	subjects: SubjectTable;
	calendars: CalendarTable;
	announcements: AnnouncementTable;
	courses: CourseTable;
	units: UnitTable;
	weeks: WeekTable;
	lessons: LessonTable;
	resources: ResourceTable;
	resourceSubmissions: ResourceSubmissionsTable;
	friendsOfDwfPartners: FriendsOfDwfPartnerTable;
	messages: MessagesTable;
	bookings: BookingsTable;
	responses: ResponsesTable;
	artistAmbassadors: ArtistAmbassadorTable;
	artistAmbassadorEvents: ArtistAmbassadorEventTable;

	constructor(apiKey: string, base: string, endpointUrl?: string) {
		super(apiKey, base, endpointUrl);

		this.teachers = new TeacherTable(this.instance);
		this.subjects = new SubjectTable(this.instance);
		this.calendars = new CalendarTable(this.instance);
		this.announcements = new AnnouncementTable(this.instance);
		this.courses = new CourseTable(this.instance);
		this.units = new UnitTable(this.instance);
		this.weeks = new WeekTable(this.instance);
		this.lessons = new LessonTable(this.instance);
		this.resources = new ResourceTable(this.instance);
		this.resourceSubmissions = new ResourceSubmissionsTable(this.instance);
		this.friendsOfDwfPartners = new FriendsOfDwfPartnerTable(this.instance);
		this.messages = new MessagesTable(this.instance);
		this.bookings = new BookingsTable(this.instance);
		this.responses = new ResponsesTable(this.instance);
		this.artistAmbassadors = new ArtistAmbassadorTable(this.instance);
		this.artistAmbassadorEvents = new ArtistAmbassadorEventTable(this.instance);
	}

	/**
	 * Reconfigure all table instances to use the proxy with a JWT token.
	 * Called after login or session restore when a proxy token is available.
	 */
	configureProxy(token: string) {
		super.reconfigure(token, PROXY_ENDPOINT);

		this.teachers = new TeacherTable(this.instance);
		this.subjects = new SubjectTable(this.instance);
		this.calendars = new CalendarTable(this.instance);
		this.announcements = new AnnouncementTable(this.instance);
		this.courses = new CourseTable(this.instance);
		this.units = new UnitTable(this.instance);
		this.weeks = new WeekTable(this.instance);
		this.lessons = new LessonTable(this.instance);
		this.resources = new ResourceTable(this.instance);
		this.resourceSubmissions = new ResourceSubmissionsTable(this.instance);
		this.friendsOfDwfPartners = new FriendsOfDwfPartnerTable(this.instance);
		this.messages = new MessagesTable(this.instance);
		this.bookings = new BookingsTable(this.instance);
		this.responses = new ResponsesTable(this.instance);
		this.artistAmbassadors = new ArtistAmbassadorTable(this.instance);
		this.artistAmbassadorEvents = new ArtistAmbassadorEventTable(this.instance);
	}
}

// Initialize with a placeholder key — the proxy token will be set after login.
// No Airtable calls should be made before configureProxy() is called.
const airtableInstance: Airtable = new Airtable("placeholder", AIRTABLE_APP, PROXY_ENDPOINT);

export default airtableInstance;
